import React, { useEffect, useRef, useState } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Prompt } from "react-router-dom";


const ConfirmWhileLoading = ({
  when,
  message = "Operation in progress. Are you sure you want to quit?",
  header = "Please Confirm",
  history,
  onCancelRequest,
}) => {
  const [visible, setVisible] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const unblockRef = useRef(null);

  // Block react-router navigation
  const handleBlockedNavigation = (nextLocation) => {
    if (when) {
      setVisible(true);
      setNextLocation(nextLocation);
      return false;
    }
    return true;
  };

  // Block browser close/refresh
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (when) {
        e.preventDefault();
        e.returnValue = ""; // triggers browser default dialog
      }
    };
    if (when) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />

      <ConfirmDialog
        visible={visible}
        onHide={() => setVisible(false)}
        message={message}
        header={header}
        rejectIcon="pi pi-exclamation-triangle"
        position="top"
        acceptLabel="Stay"
        rejectLabel="Leave"
        acceptClassName="p-button-raised"
        rejectClassName="p-button-text p-button-danger"
        accept={() => setVisible(false)}
        reject={() => {
          setVisible(false);
          if (onCancelRequest) onCancelRequest();
          if (unblockRef.current) unblockRef.current();
          if (nextLocation) history.push(nextLocation.pathname);
        }}
      />
    </>
  );
};

export default ConfirmWhileLoading;
